<template>
  <div class="canvas">
    <div class="biaoti">通讯录管理</div>

    <el-form :inline="true" class="demo-form-inline">
      <el-form-item style="float: right; padding: 10px;">
        <el-upload
          :action="uploadUrl"
          :show-file-list="false"
          :before-upload="beforeUpload"
          :on-success="handleSuccess"
          :on-error="handleError"
          :http-request="customUpload"
        >
          <el-button type="success">导入</el-button>
        </el-upload>
      </el-form-item>
      <a style="float: right; padding: 10px;" href="https://fkqy.xiao-e.tech/导入参考文档.docx" download class="download-link">
        <el-button type="primary">下载导入参考文档</el-button>
      </a>
    </el-form>

    <el-table :data="pagedRecords" style="width: 100%">
      <el-table-column prop="name" label="姓名" width="250" />
      <el-table-column prop="phone" label="手机号" width="250" />
      <el-table-column prop="erjiName" label="二级审批人" width="250" />
      <el-table-column label="操作" width="300">
        <template #default="scope">
          <el-button
            v-if="scope.row.erjiName"
            type="primary"
            @click="handleEdit(scope.row)"
          >
            修改
          </el-button>
          <el-button
            v-else
            type="success"
            @click="handleAdd(scope.row)"
          >
            添加
          </el-button>
          <el-button
            v-if="scope.row.erjiName"
            type="danger"
            @click="handleDelete(scope.row)"
          >
            删除
          </el-button>
        </template>
      </el-table-column>
    </el-table>

    <el-pagination
      background
      layout="total, prev, pager, next"
      :total="filteredTotalRecords"
      :page-size="pageSize"
      @current-change="handlePageChange"
    />

    <!-- 添加/修改审批人弹窗 -->
    <el-dialog
      title="选择二级审批人"
      :visible.sync="dialogVisible"
      width="30%"
      @close="resetDialog"
    >
      <el-form :model="formData" label-width="100px">
        <el-form-item label="审批人">
          <el-select
            v-model="formData.selectedUserid"
            placeholder="请选择审批人"
            filterable
            remote
            :remote-method="remoteMethod"
            @change="onApproverChange"
            clearable
            @clear="clearSearch"
          >
            <el-option
              v-for="user in approverList"
              :key="user.userid"
              :label="`${user.name} (${user.phone})`"
              :value="user.userid"
            />
          </el-select>
        </el-form-item>
      </el-form>

      <div slot="footer" class="dialog-footer">
        <el-button @click="clearSelection">取消</el-button>
        <el-button type="primary" @click="submitApprover">确定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import axios from 'axios';
import { Loading } from 'element-ui';

export default {
  data() {
    return {
      uploadUrl: 'https://fangke.xiao-e.tech/api/upload',
      pagedRecords: [],
      allRecords: [],
      filteredTotalRecords: 0,
      pageSize: 10,
      currentPage: 1,
      loadingInstance: null,

      dialogVisible: false,
      formData: {
        currentRow: null,
        selectedUserid: '',
        selectedName: ''
      },
      approverList: [], // 通讯录用户列表
      allApprovers: [] // 保存所有审批人的完整列表
    };
  },
  methods: {
    beforeUpload(file) {
      const isExcel =
        file.type ===
          'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' ||
        file.type === 'application/vnd.ms-excel';
      if (!isExcel) {
        this.$message.error('只能上传 Excel 文件');
      }
      return isExcel;
    },

    customUpload(request) {
      const formData = new FormData();
      formData.append('file', request.file);

      this.loadingInstance = Loading.service({
        lock: true,
        text: '正在导入，请稍候...',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.3)'
      });

      axios
        .post(this.uploadUrl, formData)
        .then((response) => {
          this.loadingInstance.close();
          this.handleSuccess(response.data);
        })
        .catch(() => {
          this.loadingInstance.close();
          this.handleError();
        });
    },

    handleSuccess(response) {
      if (response.code === 0) {
        this.$message.success('导入成功');
        this.loadTableData();
      } else {
        this.$message.error('请把手机号为空的对应行的信息删掉或添加进手机号');
      }
    },

    handleError() {
      this.$message.error('上传出错，请稍后重试');
    },

    async loadTableData() {
      try {
        const [res1, res2] = await Promise.all([
          this.$axios.get('https://fangke.xiao-e.tech/api/get_tongxunlu'),
          this.$axios.get('https://fangke.xiao-e.tech/api/get_erji_list')
        ]);

        if (res1.data.code !== 0 || res2.data.code !== 0) {
          this.$message.error('数据加载失败');
          return;
        }

        const tongxunlu = res1.data.data;
        const erjiList = res2.data.data;

        this.allApprovers = tongxunlu; // 保存所有审批人的完整列表
        this.approverList = tongxunlu; // 初始化审批人列表

        const merged = tongxunlu.map((item) => {
          const match = erjiList.find((erji) => erji.userid1 === item.userid);
          return {
            name: item.name,
            phone: item.phone,
            erjiName: match ? match.name2 : '',
            userid: item.userid
          };
        });

        this.allRecords = merged;
        this.filteredTotalRecords = merged.length;
        this.handlePageChange(1);
      } catch (error) {
        this.$message.error('网络请求异常');
        console.error(error);
      }
    },

    handlePageChange(newPage) {
      this.currentPage = newPage;
      const start = (newPage - 1) * this.pageSize;
      const end = start + this.pageSize;
      this.pagedRecords = this.allRecords.slice(start, end);
    },

    handleAdd(row) {
      this.formData.currentRow = row;
      this.formData.selectedUserid = '';
      this.formData.selectedName = '';
      this.dialogVisible = true;
    },

    handleEdit(row) {
      this.formData.currentRow = row;

      const approver = this.approverList.find(
        (user) => user.name === row.erjiName
      );
      this.formData.selectedUserid = approver ? approver.userid : '';
      this.formData.selectedName = approver ? approver.name : '';
      this.dialogVisible = true;
    },

    handleDelete(row) {
      this.$confirm('确定要删除该二级审批人吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
      .then(() => {
        this.$axios.post('/api/delete_erji_shenpi', {
            userid1: row.userid
        })
        .then((res) => {
          if (res.data.code === 0) {
            this.$message.success('删除成功');
            this.loadTableData(); // 刷新表格数据
          } else {
            this.$message.error(res.data.message || '删除失败');
          }
        })
        .catch((error) => {
          this.$message.error('网络错误');
          console.error(error);
        });
      })
      .catch(() => {
        this.$message.info('已取消删除');
      });
    },

    resetDialog() {
      this.formData = {
        currentRow: null,
        selectedUserid: '',
        selectedName: ''
      };
      this.clearSearch();
    },

    onApproverChange(selectedUserid) {
      const selected = this.approverList.find(
        (user) => user.userid === selectedUserid
      );
      if (selected) {
        this.formData.selectedName = `${selected.name} (${selected.phone})`;
      } else {
        this.formData.selectedName = '';
      }
    },

    submitApprover() {
      if (!this.formData.selectedUserid) {
        this.$message.warning('请选择审批人');
        return;
      }

      const payload = {
        yijiName: this.formData.currentRow.name,
        yijiUserid: this.formData.currentRow.userid,
        erjiName: this.formData.selectedName,
        erjiUserid: this.formData.selectedUserid
      };

      this.$axios
        .post('/api/addAndUpdateErJiShenPi', payload)
        .then((res) => {
          if (res.data.code === 0) {
            this.$message.success('操作成功');
            this.dialogVisible = false;

            this.formData.currentRow.erjiName = this.formData.selectedName;

            // 如果想刷新列表可以调用 this.loadTableData();
          } else {
            this.$message.error(res.data.message || '操作失败');
          }
        })
        .catch(() => {
          this.$message.error('网络错误');
        });
    },

    remoteMethod(query) {
      if (query !== '') {
        this.approverList = this.allApprovers.filter(item =>
          item.name.toLowerCase().includes(query.toLowerCase())
        );
      } else {
        this.approverList = this.allApprovers; // 恢复完整的审批人列表
      }
    },

    clearSearch() {
      this.approverList = this.allApprovers; // 恢复完整的审批人列表
      this.formData.selectedUserid = ''; // 清空选择的审批人
      this.formData.selectedName = ''; // 清空选择的审批人名称
    },

    clearSelection() {
      this.clearSearch();
      this.dialogVisible = false; // 关闭弹窗
    }
  },

  mounted() {
    this.loadTableData();
  }
};
</script>

<style scoped>
.demo-form-inline {
  margin-bottom: 20px;
}
.canvas {
  background-color: white;
  padding: 20px;
  border-radius: 10px;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.2);
  width: 97%;
  position: relative;
}
.biaoti {
  font-family: 'Georgia', serif;
  color: #4396e5;
  font-size: 30px;
  font-weight: bold;
  padding: 15px;
}
.download-link {
  margin-left: 10px;
}
</style>